import React, { useState } from "react";
import {
    Button,
    Popper,
    Stack,
    Typography,
} from "@mui/material";
import { Icons } from "./icons";

// floating component for get IP in console frame
export const GetIP = ({ instances = [] }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl((prev) => (prev ? null : event.currentTarget));
    };

    return (
        <Stack spacing={0}>
            {/* Button */}
            <Button
                variant="contained"
                onClick={handleClick}
                endIcon={
                    <Icons.downArrow
                        style={{
                            transform: open ? "rotate(180deg)" : "none",
                            transition: "transform 0.2s ease",
                        }}
                    />
                }
                sx={{
                    width: "fit-content",
                    backgroundColor: "rgba(0, 41, 41, 0.6)",
                    backdropFilter: "blur(4px)",
                    color: "#fff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    textTransform: "none",

                    "&:hover": {
                        backgroundColor: "#002929",
                    }
                }}
            >
                Get IP Addresses
            </Button>

            <Popper
                open={open}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal={true}
                style={{ zIndex: 1300 }}
            >
                <Stack
                    spacing={1}
                    padding={'12px'}
                    sx={{
                        borderRadius: '6px',
                        gap: '10px',
                        backgroundColor: '#151A1F',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        minWidth: '220px',
                        marginTop: "6px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
                    }}
                >
                    <Typography sx={{ color: "#BCBEC1", fontWeight: 600 }}>
                        IP Addresses
                    </Typography>
                    {instances?.some((instance) => instance?.ips?.length) ? (
                        instances.flatMap((instance) =>
                            (instance?.ips || []).map((ip, index) => (
                                <Stack
                                    key={`${instance.id}-${index}`}
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Icons.location style={{ color: "#BCBEC1" }} />
                                    <Typography sx={{ color: "#BCBEC1" }}>
                                        {instance?.name || "Instance"}:
                                    </Typography>
                                    <Typography sx={{ color: "#BCBEC1" }}>
                                        {ip?.addr}
                                    </Typography>
                                </Stack>
                            ))
                        )
                    ) : (
                        <Typography sx={{ color: "#BCBEC1" }}>
                            No IPs Found
                        </Typography>
                    )}
                </Stack>
            </Popper>
        </Stack>
    );
};